import React, { useState, useEffect } from "react";

import {
  PageWrapper,
  UpperSection,
  TitleSection,
  SearchWrapper,
  Options,
  Option,
  BottomSection,
  CategoryTitle,
  PartnersCardsWrapper,
  ParceiroText,

} from "./styles";

import storeIcon from '../../assets/images/petshop_icon.svg'
import hotelIcon from '../../assets/images/hotel_icon.svg'
import bathingIcon from '../../assets/images/dog_bathing_icon.svg'
import walkIcon from '../../assets/images/dog_walking_icon.svg'
import vetIcon from '../../assets/images/vet_icon.svg'
import taxiIcon from '../../assets/images/taxi_icon.svg'
import urnIcon from '../../assets/images/urn_icon.svg'
import outrosIcon from '../../assets/images/outros_icon.svg'
import PartnerCard from "../../components/PartnerCard";
import { ReactSearchAutocomplete } from "react-search-autocomplete";

const categoryNameMap = {
  "loja_pet" : "Loja pet",
  "hospedagem" : "Hospedagem",
  "banho_tosa" : "Banho e tosa",
  "passeio" : "Adestrador/criador",
  "auxiliar_vet" : "Auxiliar Veterinário",
  "transporte_animal" : "Transporte Animal",
  "crematorio" : "Crematório",
  "outros" : "Outros", 
}

function Partners() {

  const [currentCity, setCurrentCity] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null)
  const [currentCategoryName, setCurrentCategoryName] = useState(null)
  const [currentPartners, setCurrentPartners] = useState([])
  const [partnersData, setPartnersData] = useState(null)
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const options = { method: 'GET' };
    fetch('https://www.redevidaanimal.com/api/v1/parceiros', options)
      .then(response => response.json())
      .then(response => setPartnersData(response.resultado))
      .catch(err => console.error(err));
  }, [])

  useEffect(() => {
    setCities([]);
    if (partnersData != null) {
      for (let i = 0; i < partnersData.length; i++) {
        setCities(oldCities => [...oldCities, { id: i, cidade: partnersData[i].endereco.cidade }]);
      }
      setCities(oldCities => oldCities.filter((value, index, self) => {
        return self.findIndex(v => v.cidade === value.cidade) === index;
      }))
    }
  }, [partnersData])


  function getPartners(category) {
    if (partnersData) {
      if (currentCity) {
        const partners = partnersData
          .filter(partner => (partner.endereco.cidade === currentCity))
          .filter(partner => partner.categorias.includes(category));
        setCurrentPartners(partners);
      } 
      else {
        setCurrentPartners(partnersData.filter((partner) => partner.categorias.includes(category)));
      }
    }
  }

  const handleOptionOnSelect = (categoryName) => {
    setCurrentCategoryName(categoryNameMap[categoryName]); 
    setCurrentCategory(categoryName); 
    getPartners(categoryNameMap[categoryName])
  }

  const handleOnSelect = (item) => {
    if (currentCategory) {
      const partners = partnersData
        .filter(partner => (partner.endereco.cidade === item.cidade))
        .filter(partner => partner.categorias[currentCategory.toLowerCase()]);
      setCurrentPartners(partners);
    } else {
      setCurrentPartners(partnersData.filter(partners => partners.endereco.cidade === item.cidade));
      setCurrentCategory(item.cidade);
      setCurrentCategoryName(item.cidade)
    }
    setCurrentCity(item.cidade);
  }

  const handleOnClear = () => {
    if (currentCategory !== currentCity) {
      setCurrentPartners(partnersData.filter((partner) => partner.categorias.includes(currentCategory.toLowerCase())));
    }
    else { 
      setCurrentPartners([]); 
      setCurrentCategory(null); 
    }
    setCurrentCity(null);
  }

  return (
    <PageWrapper>
      <UpperSection>
        <TitleSection>
          <h1> Parceiros </h1>
          <h2> Procure por um dos nossos parceiros que indicamos em sua cidade e tenha um atendimento de qualidade, benefícios, descontos, e muito mais! </h2>
          <h2>Basta selecionar sua cidade e uma categoria a seguir </h2>

          <SearchWrapper>
            <ReactSearchAutocomplete
              items={cities}
              fuseOptions={
                { 
                  keys: ["cidade"],
                  threshold: 0.5,
                  minMatchCharLength: 2
                }
              }
              resultStringKeyName="cidade"
              placeholder='Procure aqui a cidade'
              autoFocus
              onSelect={handleOnSelect}
              onClear={handleOnClear}
              showNoResultsText="Sem resultados"
              styling={{

                borderRadius: "8px",
                backgroundColor: "#E6E6E6",
                color: "#555",
                fontFamily: "Poppins",
                hoverBackgroundColor: "#E0E0E0",
                placeholderColor: "black"
              }}
            />
          </SearchWrapper>
        </TitleSection>
        <Options>
          <Option onClick={() => handleOptionOnSelect('loja_pet')} isCurrent={(currentCategory === 'loja_pet')} >
            <img src={storeIcon} alt="" />
            <h1> Loja pet </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('hospedagem')} isCurrent={(currentCategory === 'hospedagem')} >
            <img src={hotelIcon} alt="" />
            <h1> Hospedagem </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('banho_tosa')} isCurrent={(currentCategory === 'banho_tosa')} >
            <img src={bathingIcon} alt="" />
            <h1> Banho e tosa </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('passeio')} isCurrent={(currentCategory === 'passeio')} >
            <img src={walkIcon} alt="" />
            <h1> Adestrador/criador </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('auxiliar_vet')} isCurrent={(currentCategory === 'auxiliar_vet')} >
            <img src={vetIcon} alt="" />
            <h1> Auxiliar Veterinário </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('transporte_animal')} isCurrent={(currentCategory === 'transporte_animal')} >
            <img src={taxiIcon} alt="" />
            <h1> Transporte Animal </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('crematorio')} isCurrent={(currentCategory === 'crematorio')} >
            <img src={urnIcon} alt="" />
            <h1> Crematório </h1>
          </Option>
          <Option onClick={() => handleOptionOnSelect('outros')} isCurrent={(currentCategory === 'outros')} >
            <img src={outrosIcon} alt="" />
            <h1> Outros </h1>
          </Option>
        </Options>
      </UpperSection>
      <BottomSection>
        {currentCategory ? (
          <>
            <CategoryTitle>
              <h1>{currentCategoryName.toUpperCase()}</h1>
            </CategoryTitle>
            {(currentCity || currentCategory) && currentPartners.length === 0 && 
              <ParceiroText> Sem parceiros no momento <br></br> </ParceiroText>
            }
            <PartnersCardsWrapper total={currentPartners.length}>
              {currentPartners.map((partner) =>
                (<PartnerCard 
                  key={partner.id} 
                  id={partner.id} 
                  name={partner.nome} 
                  city={partner.endereco.cidade}
                  specialties={partner.especialidades} 
                  benefits={partner.servicos}
                />))
              }
            </PartnersCardsWrapper>
          </>
        ) : (<div />)}
      </BottomSection>
    </PageWrapper>
  )
}

export default Partners